import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { BuildingType } from "api/schema";
import { getBuildingStructureForDesks } from "gql/queries/building/buildingStructureForDesks";
import { DateUtils } from "shared/utils/date";

interface GqlData {
  building: BuildingType;
}

interface GqlVars {
  buildingId: string;
  date: string;
}

type OnSettled = (data: BuildingType) => void;

interface QueryParams {
  building?: BuildingType;
  date?: Date | string;
}

export function useBuildingStructureForDesks(
  onSettled?: OnSettled,
  params?: QueryParams,
) {
  const q = useQuery<GqlData, GqlVars>(getBuildingStructureForDesks, {
    variables: {
      buildingId: params?.building?.id ?? "",
      date: DateUtils.formatDate(params?.date ?? new Date()),
    },
    skip: !params?.building?.id,
  });

  useEffect(() => {
    if (q.data?.building) {
      onSettled?.(q.data.building);
    }
  }, [q.data]);

  return q;
}
